import React, { useState } from "react";
import { Button } from "../../components/AdminSharedComponents";
import ProjectCard from "./ProjectCard";

const ProjectList = ({
  projects,
  projectReports,
  onDeleteClick,
  onOpenReportModal,
  userRole,
  filteredCount,
  paginatedCount,
  searchTerm,
  filter,
}) => {
  const [expandedProjects, setExpandedProjects] = useState(new Set());

  const toggleExpand = (projectId) => {
    setExpandedProjects((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(projectId)) {
        newSet.delete(projectId);
      } else {
        newSet.add(projectId);
      }
      return newSet;
    });
  };

  const expandAll = () =>
    setExpandedProjects(new Set(projects.map((p) => p.id)));
  const collapseAll = () => setExpandedProjects(new Set());

  return (
    <div className="space-y-4">
      {projects.length > 0 && (
        <div className="flex justify-between items-center mb-4">
          <div className="text-lg text-primary font-semibold">
            Showing {paginatedCount} of {filteredCount} project
            {filteredCount !== 1 ? "s" : ""}
            {(searchTerm || filter !== "all") && " matching your criteria"}
          </div>
          <div className="hidden md:flex gap-2">
            <Button variant="secondary" size="sm" onClick={expandAll}>
              Expand All
            </Button>
            <Button variant="secondary" size="sm" onClick={collapseAll}>
              Collapse All
            </Button>
          </div>
        </div>
      )}

      <div className="space-y-4">
        {projects.map((project) => (
          <ProjectCard
            key={project.id}
            project={project}
            reports={projectReports[project.id]}
            onDeleteClick={onDeleteClick}
            onOpenReportModal={onOpenReportModal}
            userRole={userRole}
            isExpanded={expandedProjects.has(project.id)}
            onToggleExpand={() => toggleExpand(project.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default ProjectList;
